module.exports = __webpack_public_path__ + "img/green.09e900c1.svg";